import EscriptTable from '@/components/escript/EscriptTable';
import EscriptUploadBtn from '@/components/escript/EscriptUploadBtn';
import { EscriptUploadModal } from '@/components/escript/EscriptUploadModal';
import AdminPageLayout from '@/components/layout/AdminPageLayout';
import { EscriptOnboardingProvider } from '@/context/escript/EscriptOnboardingProvider';
import { PharmacistEscriptProvider } from '@/context/escript/EscriptProvider';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';

function PharmacistEscript() {
  const { key } = usePortalPartnerBrand();

  return (
    <AdminPageLayout title="eScript" themeVariant={key} testId="eScript">
      <EscriptOnboardingProvider>
        <EscriptUploadBtn />
        <EscriptUploadModal />
      </EscriptOnboardingProvider>

      <PharmacistEscriptProvider>
        <EscriptTable />
      </PharmacistEscriptProvider>
    </AdminPageLayout>
  );
}

export default PharmacistEscript;
